import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";

const UpdateScreenModal = ({
  isUpdateOpen,
  closeUpdateModal,
  uploadAndSaveImg,
  selectedImgUrl,
  selectedText,
}) => {
  const [text, setText] = useState("");
  const [img, setImg] = useState(null);
  const [errors, setErrors] = useState({ text: "" });

  useEffect(() => {
    setImg(null);
    setText(selectedText);
  }, [selectedText, isUpdateOpen]);

  const validateFields = () => {
    let newErrors = { text: "" };
    if (!text) {
      newErrors.text = "Text is required.";
    } else if (text.trim().split(" ").length > 15) {
      newErrors.text = "Text must be 15 words or fewer.";
    }
    setErrors(newErrors);
    return !newErrors.text; // Return true if no errors
  };

  const handleSave = () => {
    if (!validateFields()) return; // Validate before saving
    uploadAndSaveImg(img, text, "update");
    closeUpdateModal();
  };

  return (
    <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Welcome Screen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <img src={selectedImgUrl} className="img-fluid" alt="Selected" />
        </div>
        <div className="mb-3">
          <Input
            label="Image"
            type="file"
            accept="image/png, image/jpeg"
            onChange={(e) => setImg(e.target.files[0])}
          />
          {errors.img && <div className="text-danger">{errors.img}</div>}
        </div>
        <div className="mb-3">
          <Input
            label="Text"
            type="textarea"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          {errors.text && <div className="text-danger">{errors.text}</div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeUpdateModal} />
        <Button text="Save Changes" callBack={handleSave} />
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateScreenModal;
